import {
  Button,
  Card,
  Inline,
  Notification,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { ContractorInvoiceBankTransferDetails } from '@omnipresentgroup/features';
import type { ContractorPayment, PaymentMethod } from '@omnipresentgroup/types';

const NOFICATION_TITLE =
  'Do not forget to include your reference code in the transaction';
const NOFICATION_DESCRIPTION =
  'These details are saved, so you will be able to access them for 24 hours';

type Props = {
  selectedPaymentMethod: PaymentMethod;
  payment: ContractorPayment;
  onDone: () => void;
};

export const TransferDetailsStep = ({
  selectedPaymentMethod,
  payment,
  onDone,
}: Props) => {
  return (
    <Card maxW={600} w="stretch">
      <Stack bg="primary" p="32" gap="24">
        <Stack gap="8">
          <Typography size="20" as="h4" weight="medium">
            Manual bank transfer details
          </Typography>
          <Typography size="14" as="span" color="subtle">
            You’ll need to log into your banking environment and make the
            transfer using the details below. Depending on where you are
            transferring from, you may or may not need all the details listed.{' '}
            <br />
          </Typography>
          <Typography size="14" as="span" color="subtle">
            Ensure you list the correct account details and
            reference/description codes.
          </Typography>
        </Stack>

        <Notification
          id={`notification-${payment.id}`}
          intent="warning"
          title={NOFICATION_TITLE}
          description={NOFICATION_DESCRIPTION}
        />

        <ContractorInvoiceBankTransferDetails
          payment={payment}
          border={false}
        />

        <Inline justify="flex-end">
          <Button disabled={!selectedPaymentMethod} onClick={onDone}>
            Done
          </Button>
        </Inline>
      </Stack>
    </Card>
  );
};
